// extracted by mini-css-extract-plugin
export default {"relativeProfile":"RelativeTab_relativeProfile__+cPCq"};